import React, { useEffect, useState } from 'react';

import { InputGroup, TextField } from '../../../../../../Styles';

import { formatCurrency, stripCurrency } from '../../../../../../../commons/utils';

const PricePerItem = ({ label = 'Price', value = '', error = '', required = true, disabled = false, onChange = null, onError = null }) => {
	const [inputValue, setInputValue] = useState(value);

	const validate = () => {
		let error = null;

		if (required && ['', undefined, null].includes(stripCurrency(inputValue))) {
			error = `${label} cannot be empty.`;
		}

		onError(error);
		return !error;
	};

	useEffect(() => {
		validate();
		onChange(stripCurrency(inputValue));
	}, [inputValue]);

	useEffect(() => {
		setInputValue(value);
	}, [value]);

	return (
		<InputGroup
			label={label}
			markRequired={required}
			error={error}
		>
			<TextField
				name={'price_per_item'}
				placeholder='$0.000'
				value={formatCurrency(inputValue)}
				disabled={disabled}
				onBlur={(e) => {
					setInputValue(stripCurrency(formatCurrency(e.target.value, true)));
				}}
				onChange={(e) => {
					
					setInputValue(formatCurrency(e.target.value));
				}}
				error={error}
			/>
		</InputGroup>
	);
};

export default PricePerItem;
